module.exports = __webpack_public_path__ + "static/media/edit.80fc91e5.svg";